// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/front/unocms-v4/app.scss
// module id = 21
// module chunks = 0